<template>
    <v-card flat>
        <v-row no-gutters>
            <v-col cols="12">{{ order.billing_address?.company }}</v-col>
            <v-col cols="12">{{ order.billing_address?.name }}</v-col>
            <v-col cols="12">{{ order.billing_address?.address1 }}</v-col>
            <v-col cols="12">{{ order.billing_address?.address2 }}</v-col>
            <v-col cols="12">{{ order.billing_address?.city }} {{ order.billing_address?.province_code }} {{ order.billing_address?.country_code }} {{ order.billing_address?.zip }}</v-col>
            <v-col cols="12" class="mt-3">
                <span v-if="order.billing_address?.phone"><span class="font-weight-bold">Telephone: </span>{{ order.billing_address?.phone }} </span>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
    props: ['order'],
    computed : {
        ...mapState('User', ['address']),
    }
}
</script>